import { toast } from 'sonner';

/**
 * Toast utility functions for consistent toast notifications across the app.
 * Uses Sonner under the hood - these are wrappers with consistent styling.
 *
 * For E2E tests, use Sonner's built-in data-type attributes:
 * - Success: [data-sonner-toast][data-type="success"]
 * - Error: [data-sonner-toast][data-type="error"]
 * - Info: [data-sonner-toast][data-type="info"]
 * - Warning: [data-sonner-toast][data-type="warning"]
 *
 * Additional class selectors are also available via Toaster configuration:
 * - .toast-success, .toast-error, .toast-info, .toast-warning
 */

export const showSuccessToast = (message: string, description?: string) => {
  toast.success(message, { description, duration: 5000 });
};

export const showErrorToast = (message: string, description?: string) => {
  toast.error(message, { description, duration: 5000 });
};

export const showWarningToast = (message: string, description?: string) => {
  toast.warning(message, { description, duration: 10000 });
};

export const showInfoToast = (message: string, description?: string) => {
  toast.info(message, { description, duration: 5000 });
};

/**
 * Dismiss all toasts (useful when navigating away or after logout)
 */
export const dismissAllToasts = () => {
  toast.dismiss();
};
